$(function() {
	var sidebarMenu = $('.sidebar_menu');
	if (!sidebarMenu.length)
		return;

	var path = document.location.pathname;
	var active = sidebarMenu.find('a[href$="' + path + '"]').parent();
	active.addClass('current');
});